import { Bovemij } from "../../constants";
import $ from "jquery";

/**
 * License plate utility to validate and format license plates.
 */

const LICENSE_PLATE_PARTS_PATTERN = new RegExp("[A-Z]+|[0-9]+", "g");
const LICENSE_PLATE_PATTERNS = [
  // 1	1951	XX-99-99
  new RegExp("^[A-Z]{2}-?[0-9]{2}-?[0-9]{2}$"),
  // 2	1965	99-99-XX
  new RegExp("^[0-9]{2}-?[0-9]{2}-?[A-Z]{2}$"),
  // 3	1973	99-XX-99
  new RegExp("^[0-9]{2}-?[A-Z]{2}-?[0-9]{2}$"),
  // 4	1978	XX-99-XX
  new RegExp("^[A-Z]{2}-?[0-9]{2}-?[A-Z]{2}$"),
  // 5	1991    XX-XX-99
  new RegExp("^[A-Z]{2}-?[A-Z]{2}-?[0-9]{2}$"),
  // 6	1999	99-XX-XX
  new RegExp("^[0-9]{2}-?[A-Z]{2}-?[A-Z]{2}$"),
  // 7	2005	99-XXX-9
  new RegExp("^[0-9]{2}-?[A-Z]{3}-?[0-9]$"),
  // 8	2009	9-XXX-99
  new RegExp("^[0-9]-?[A-Z]{3}-?[0-9]{2}$"),
  // 9	2006	XX-999-X
  new RegExp("^[A-Z]{2}-?[0-9]{3}-?[A-Z]$"),
  // 10	2008	X-999-XX
  new RegExp("^[A-Z]-?[0-9]{3}-?[A-Z]{2}$"),
  // 11	2015	XXX-99-X
  new RegExp("^[A-Z]{3}-?[0-9]{2}-?[A-Z]$"),
  // 12 2024  X-99-XXX
  new RegExp('^[A-Z]{1}-?[0-9]{2}-?[A-Z]{3}$'),
  // 13 2024  9-XX-999
  new RegExp('^[0-9]{1}-?[A-Z]{2}-?[0-9]{3}$'),
  // 14 2024  999-XX-9
  new RegExp('^[0-9]{3}-?[A-Z]{2}-?[0-9]{1}$')
];

/**
 * @param licensePlate License plate to validate
 * @returns {boolean} true if license plate is valid
 */
export function isValid(licensePlate) {
  licensePlate = (licensePlate || "").toUpperCase();

  return (
    licensePlate &&
    LICENSE_PLATE_PATTERNS.some(function(regex) {
      return regex.test(licensePlate);
    })
  );
}

/**
 * @param licensePlate License plate to trim
 * @returns the trimmed license plate, having all illegal characters removed (including hyphens)
 */
export function trim(licensePlate) {
  return licensePlate.replace(/[^0-9a-z]/gi, "");
}

/**
 * Formats the license plate. Convert to uppercase and add hyphens.
 *
 * @param licensePlate License plate to format
 * @returns {string} Formatted uppercase license.
 */
export function format(licensePlate) {
  let parts;

  licensePlate = (licensePlate || "").toUpperCase();

  // When license plate is not valid return license plate
  if (!isValid(licensePlate)) {
    return licensePlate;
  }

  parts = licensePlate.match(LICENSE_PLATE_PARTS_PATTERN);

  return [].concat
    .apply(
      [],
      parts.map(function(part) {
        return part.length === 4 ? part.match(/.{2}/g) : part;
      })
    )
    .join("-");
}

/**
 * Format all content in elements with class '.format-license-plate'.
 */
export function formatLicensePlateElements() {
  $(".format-license-plate").each(function() {
    $(this).text(format($(this).text()));
  });
}

// Expose
Bovemij.LicensePlateUtil = {
  isValid: isValid,
  format: format,
  formatLicensePlateElements: formatLicensePlateElements
};
